import { useState } from 'react';

import type { PaginationState } from './types';

export default function usePaginationState(
  initialState: PaginationState | (() => PaginationState),
) {
  const [pageState, setPageState] = useState<PaginationState>(initialState);

  return [pageState, setPageState] as const;
}
